import { ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading } from "utils/Constant";
import { useModal } from "../../components/modal/ModalContext";


export default function Dashboard(){
    const {openModal, closeModal} = useModal()

    return (
        <>
      <button
        onClick={() =>
          openModal(ModalTypeLoading)
        }
      >
        Show Loading
      </button>

      <button
        onClick={() =>
          openModal(ModalTypeFail, { message: "Something went wrong" })
        }
      >
        Show Error
      </button>

      <button
        onClick={() =>
          openModal(ModalTypeConfirmation, {
            title: "Delete item?",
            onConfirm: () => {
              console.log("Confirmed");
              closeModal();
            },
          })
        }
      >
        Show Confirm
      </button>
    </>
    )

}